import { MatchKeyHost } from "@/components/MatchKey/MatchKeyShell";
import { KARNOFFEL_CFG } from "@/components/MatchKey/cfgs";

export default function KarnoffelHostPage() {
  return <MatchKeyHost cfg={KARNOFFEL_CFG} />;
}
